import { FC, useEffect, useState } from 'react';
import { IconMap } from '../../../../../shared/sprite';
import { Button, Dropdown, Icon, SearchInput } from '../../../../../shared/ui';
import { TabsSwitcher } from '../shared';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useDispatch, useSelector } from 'react-redux';
import { callModel } from '../../../../../features/call';
import { callsTabs, CallTab } from './lib/config';

const sortItems = [
  { label: 'Last created', id: 'createdAt' },
  { label: 'Name', id: 'name' },
];

export const CallsHeader: FC = () => {
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState<CallTab>(CallTab.MY);

  const callListOptions = useSelector(
    callModel.selectors.selectCallListOptions
  );

  const [isSearchInputOpen, setIsSearchInputOpen] = useState(false);

  const onSearchChange = (value: string) => {
    dispatch(
      callModel.actions.setListOptions({
        ...callListOptions,
        type: value
          ? 'all'
          : selectedTab === CallTab.TEAM
          ? 'team'
          : 'personal',
        search: value || undefined,
      })
    );
    dispatch(callModel.actions.loadCallsForEditor());
  };

  const handleSortChange = (sortId: string) => {
    dispatch(
      callModel.actions.setListOptions({
        ...callListOptions,
        sortBy: sortId as 'name' | 'createdAt',
      })
    );
    dispatch(callModel.actions.loadCallsForEditor());
  };

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab as CallTab);

    dispatch(callModel.actions.resetOptions());
    dispatch(
      callModel.actions.setListOptions({
        type: tab === CallTab.TEAM ? 'team' : 'personal',
      })
    );
    dispatch(callModel.actions.loadCallsForEditor());
  };

  useEffect(() => {
    dispatch(callModel.actions.loadCallsForEditor());
  }, [dispatch]);

  return (
    <div>
      <div className="flex items-center gap-2">
        {isSearchInputOpen ? (
          <div className="flex w-full gap-2">
            <div className="relative w-full">
              <SearchInput
                value={callListOptions.search || ''}
                onChange={onSearchChange}
                placeholder="Search"
              />
            </div>
            <Button
              size="md"
              color="transparent"
              variant="icon"
              onClick={() => {
                setIsSearchInputOpen(false);
                onSearchChange('');
              }}
            >
              <Icon glyph={IconMap.XClose} width={20} />
            </Button>
          </div>
        ) : (
          <>
            <TabsSwitcher
              tabs={callsTabs}
              selectedTab={selectedTab}
              setSelectedTab={handleTabChange}
            />
            <Button
              color="secondary"
              variant="icon"
              size="md"
              onClick={() => setIsSearchInputOpen(true)}
            >
              <Icon glyph={IconMap.SearchLg} width={20} />
            </Button>
            <Dropdown
              listStyles="shadow-lg"
              items={sortItems}
              currentItemId={callListOptions.sortBy}
              itemStyles="min-w-37.5 sm:min-w-full"
              arrowStyle="text-gray-800"
              onItemChange={handleSortChange}
              triggerComponent={
                <DropdownMenu.Trigger className="flex items-center justify-center w-10 h-10 border border-gray-300 rounded-md shadow-xs min-w-10">
                  <Icon
                    glyph={IconMap.SwitchVertical01}
                    width={20}
                    className="text-gray-800"
                  />
                </DropdownMenu.Trigger>
              }
            />
          </>
        )}
      </div>
    </div>
  );
};
